import { Heart, Users, PenLine, Calendar } from "lucide-react";
import type { IntroCard } from "@shared/lib/walkthrough/types";

export const introCards: IntroCard[] = [
  {
    icon: Heart,
    title: "Welcome to cradleOS",
    description:
      "Your classroom management tools, right in your pocket.",
  },
  {
    icon: Users,
    title: "Your Classrooms",
    description:
      "Monitor ratio compliance, check-in status, and daily rosters at a glance.",
  },
  {
    icon: PenLine,
    title: "Log Activities",
    description:
      "Record meals, naps, diaper changes, and group activities with a single tap.",
  },
  {
    icon: Calendar,
    title: "Your Schedule",
    description:
      "View your weekly shifts, request time off, and stay organized.",
  },
];
